import React from 'react';
import { useAuth } from '../context/AuthContext';
import AppSidebar from './AppSidebar';
import TopBar from './TopBar';
import BottomNav from './BottomNav';
import ViewAsBanner from './ViewAsBanner';
import { getModuleForPage, mobileTabs } from '../config/modules';
import '../styles/MainLayout.css';

/**
 * The shell every signed-in page renders through.
 *
 * A grouped sidebar on desktop, a bottom tab bar on a phone, and a quiet top
 * bar carrying context and the global controls. The hub-of-rooms this replaced
 * made you pick a room before you could pick a page, which turned the landing
 * screen into a menu instead of a dashboard — the landing screen is the
 * command centre now, and navigation lives in the sidebar where it belongs.
 */
function MainLayout({ children, currentPage = 'dashboard' }) {
  const { user } = useAuth();

  // Carry the active room's accent through the layout so a page still says
  // which room it belongs to now that no sidebar is doing it.
  const activeModule = getModuleForPage(currentPage, user);
  const layoutStyle = activeModule ? { '--module-accent': activeModule.accent } : undefined;

  // Every role has a tab bar now, so the page always has to end above it.
  const hasTabBar = !!mobileTabs(user);

  return (
    <div className={`main-layout${hasTabBar ? ' has-tab-bar' : ''}`} style={layoutStyle}>
      <AppSidebar />
      <div className="main-column">
        {/* Above the top bar, so a preview is the first thing you see and the
            way out is never scrolled off. */}
        <ViewAsBanner />
        <TopBar currentPage={currentPage} />
        <main className="main-content">
          {children}
        </main>
      </div>
      <BottomNav currentPage={currentPage} />
    </div>
  );
}

export default MainLayout;
